import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import authService from '../../services/auth';
import '../../styles/Sidebar.css';

const Sidebar = ({ isOpen, onClose }) => {
  const navigate = useNavigate();
  const user = authService.getCurrentUser();
  
  const [openDropdowns, setOpenDropdowns] = useState({
    master: false,
    student: false,
    attendance: false,
    sms: false,
    reports: false,
    others: false,
  });

  // Auto-close sidebar when clicking outside
  useEffect(() => {
    const handleClickOutside = (e) => {
      const sidebar = document.querySelector('.sidebar');
      const sidebarToggle = document.querySelector('.sidebar-toggle');
      
      if (isOpen && sidebar && !sidebar.contains(e.target) && !sidebarToggle?.contains(e.target)) {
        onClose();
      }
    };

    if (isOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isOpen, onClose]);

  const toggleDropdown = (dropdownName) => {
    setOpenDropdowns((prev) => ({
      ...prev,
      [dropdownName]: !prev[dropdownName],
    }));
  };

  const handleNavigation = (link) => {
    navigate(link);
    onClose();
  };

  const handleLogout = async () => {
    if (window.confirm('Are you sure you want to logout?')) {
      await authService.logout();
    }
  };

  return (
    <>
      <div className={`sidebar-overlay ${isOpen ? 'active' : ''}`} onClick={onClose}></div>
      <div className={`sidebar ${isOpen ? 'open' : ''}`}>
        <div className="sidebar-header">
          <h2>Main Menu</h2>
          <button className="close-sidebar" onClick={onClose}>✕</button>
        </div>

        {/* Login Details */}
        <div className="user-details">
          <div className="user-avatar">
            {user?.full_name?.charAt(0).toUpperCase() || 'U'}
          </div>
          <div className="user-info-sidebar">
            <div className="user-name-sidebar">{user?.full_name || 'User'}</div>
            <div className="user-email-sidebar">{user?.email || ''}</div>
            <div className="user-role-badge">{user?.role || 'Member'}</div>
          </div>
        </div>

        <div className="sidebar-divider"></div>

        <nav className="sidebar-nav">
          {/* 1. My Profile */}
          <button className="sidebar-item" onClick={() => handleNavigation('/admin/profile')}>
            <span className="sidebar-icon">👤</span>
            <span className="sidebar-title">My Profile</span>
          </button>

          <div className="sidebar-divider"></div>

          {/* 2. Add Inquiry - Navigate to same page as Header button */}
          <button className="sidebar-item" onClick={() => handleNavigation('/admin/inquiries')}>
          <span className="sidebar-icon">📝</span>
          <span className="sidebar-title">Add Inquiry</span>
          </button>

          <div className="sidebar-divider"></div>

          {/* 3. Master Dropdown */}
        <div className="sidebar-dropdown">
          <button 
            className={`sidebar-item dropdown-toggle ${openDropdowns.master ? 'active' : ''}`}
            onClick={() => toggleDropdown('master')}
          >
            <span className="sidebar-icon">📋</span>
            <span className="sidebar-title">Master</span>
            <span className="dropdown-arrow">{openDropdowns.master ? '▴' : '▾'}</span>
          </button>
          {openDropdowns.master && (
            <div className="dropdown-menu">
              <button className="dropdown-item" onClick={() => handleNavigation('/admin/master/certification')}>
                <span className="dropdown-icon">🎓</span>
                Certification
              </button>
              <button className="dropdown-item" onClick={() => handleNavigation('/admin/master/courses')}>
                <span className="dropdown-icon">📚</span>
                Manage Courses
              </button>
              <button className="dropdown-item" onClick={() => handleNavigation('/admin/master/subjects')}>
                <span className="dropdown-icon">📖</span>
                Manage Subject
              </button>
              <button className="dropdown-item" onClick={() => handleNavigation('/admin/master/batches')}>
                <span className="dropdown-icon">⏰</span>
                Manage Batch
              </button>
              <button className="dropdown-item" onClick={() => handleNavigation('/admin/master/fees')}>
                <span className="dropdown-icon">💰</span>
                Enrolment Fee
              </button>
              <button className="dropdown-item" onClick={() => handleNavigation('/admin/master/taxes')}>
                <span className="dropdown-icon">💵</span>
                Manage Tax
              </button>
            </div>
          )}
        </div>


          <div className="sidebar-divider"></div>

          {/* 4. Student Dropdown */}
          <div className="sidebar-dropdown">
            <button 
              className={`sidebar-item dropdown-toggle ${openDropdowns.student ? 'active' : ''}`}
              onClick={() => toggleDropdown('student')}
            >
              <span className="sidebar-icon">🎓</span>
              <span className="sidebar-title">Student</span>
              <span className="dropdown-arrow">{openDropdowns.student ? '▴' : '▾'}</span>
            </button>
            {openDropdowns.student && (
              <div className="dropdown-menu">
                <button className="dropdown-item" onClick={() => handleNavigation('/admin/student/add')}>
                  <span className="dropdown-icon">➕</span>
                  Add Student
                </button>
                <button className="dropdown-item" onClick={() => handleNavigation('/admin/student/manage')}>
                  <span className="dropdown-icon">👥</span>
                  Manage Student
                </button>
              </div>
            )}
          </div>

          <div className="sidebar-divider"></div>

          {/* 5. Attendance Dropdown */}
          <div className="sidebar-dropdown">
            <button 
              className={`sidebar-item dropdown-toggle ${openDropdowns.attendance ? 'active' : ''}`}
              onClick={() => toggleDropdown('attendance')}
            >
              <span className="sidebar-icon">📅</span>
              <span className="sidebar-title">Attendance</span>
              <span className="dropdown-arrow">{openDropdowns.attendance ? '▴' : '▾'}</span>
            </button>
            {openDropdowns.attendance && (
              <div className="dropdown-menu">
                <button className="dropdown-item" onClick={() => handleNavigation('/admin/attendance/add')}>
                  <span className="dropdown-icon">➕</span>
                  Add Attendance
                </button>
                <button className="dropdown-item" onClick={() => handleNavigation('/admin/attendance/mark')}>
                  <span className="dropdown-icon">✓</span>
                  Mark Attendance
                </button>
                <button className="dropdown-item" onClick={() => handleNavigation('/admin/attendance/manage')}>
                  <span className="dropdown-icon">📋</span>
                  Manage Attendance
                </button>
                <button className="dropdown-item" onClick={() => handleNavigation('/admin/attendance/module')}>
                  <span className="dropdown-icon">📚</span>
                  Module wise Attendance
                </button>
                <button className="dropdown-item" onClick={() => handleNavigation('/admin/attendance/batch')}>
                  <span className="dropdown-icon">👥</span>
                  Batch wise Attendance
                </button>
              </div>
            )}
          </div>

          <div className="sidebar-divider"></div>

          {/* 6. SMS Dropdown */}
          <div className="sidebar-dropdown">
            <button 
              className={`sidebar-item dropdown-toggle ${openDropdowns.sms ? 'active' : ''}`}
              onClick={() => toggleDropdown('sms')}
            >
              <span className="sidebar-icon">💬</span>
              <span className="sidebar-title">SMS</span>
              <span className="dropdown-arrow">{openDropdowns.sms ? '▴' : '▾'}</span>
            </button>
            {openDropdowns.sms && (
              <div className="dropdown-menu">
                <button className="dropdown-item" onClick={() => handleNavigation('/admin/sms/template')}>
                  <span className="dropdown-icon">📄</span>
                  SMS Template
                </button>
                <button className="dropdown-item" onClick={() => handleNavigation('/admin/sms/history')}>
                  <span className="dropdown-icon">📜</span>
                  SMS History
                </button>
                <button className="dropdown-item" onClick={() => handleNavigation('/admin/sms/bulk')}>
                  <span className="dropdown-icon">📨</span>
                  Bulk Message
                </button>
              </div>
            )}
          </div>

          <div className="sidebar-divider"></div>

          {/* 7. Manage Expenses */}
          <button className="sidebar-item" onClick={() => handleNavigation('/admin/expenses')}>
            <span className="sidebar-icon">💳</span>
            <span className="sidebar-title">Manage Expenses</span>
          </button>

          <div className="sidebar-divider"></div>

          {/* 8. Reports Dropdown */}
          <div className="sidebar-dropdown">
            <button 
              className={`sidebar-item dropdown-toggle ${openDropdowns.reports ? 'active' : ''}`}
              onClick={() => toggleDropdown('reports')}
            >
              <span className="sidebar-icon">📊</span>
              <span className="sidebar-title">Reports</span>
              <span className="dropdown-arrow">{openDropdowns.reports ? '▴' : '▾'}</span>
            </button>
            {openDropdowns.reports && (
              <div className="dropdown-menu">
                <button className="dropdown-item" onClick={() => handleNavigation('/admin/reports/students')}>
                  <span className="dropdown-icon">👥</span>
                  Students Report
                </button>
                <button className="dropdown-item" onClick={() => handleNavigation('/admin/reports/course')}>
                  <span className="dropdown-icon">📚</span>
                  Course Wise Report
                </button>
                <button className="dropdown-item" onClick={() => handleNavigation('/admin/reports/collection')}>
                  <span className="dropdown-icon">💰</span>
                  Collection Report
                </button>
                <button className="dropdown-item" onClick={() => handleNavigation('/admin/reports/graph')}>
                  <span className="dropdown-icon">📈</span>
                  Collection Graph
                </button>
                <button className="dropdown-item" onClick={() => handleNavigation('/admin/reports/expense')}>
                  <span className="dropdown-icon">💳</span>
                  Expense Report
                </button>
              </div>
            )}
          </div>

          <div className="sidebar-divider"></div>

          {/* 9. Manage Users */}
          <button className="sidebar-item" onClick={() => handleNavigation('/admin/users')}>
            <span className="sidebar-icon">👤</span>
            <span className="sidebar-title">Manage Users</span>
          </button>

          <div className="sidebar-divider"></div>

          {/* 10. Others Dropdown */}
          <div className="sidebar-dropdown">
            <button 
              className={`sidebar-item dropdown-toggle ${openDropdowns.others ? 'active' : ''}`}
              onClick={() => toggleDropdown('others')}
            >
              <span className="sidebar-icon">⚙️</span>
              <span className="sidebar-title">Others</span>
              <span className="dropdown-arrow">{openDropdowns.others ? '▴' : '▾'}</span>
            </button>
            {openDropdowns.others && (
              <div className="dropdown-menu">
                <button className="dropdown-item" onClick={() => handleNavigation('/admin/notice')}>
                  <span className="dropdown-icon">📢</span>
                  Manage Notice
                </button>
                <button className="dropdown-item" onClick={() => handleNavigation('/admin/theme')}>
                  <span className="dropdown-icon">🎨</span>
                  Theme
                </button>
                <button className="dropdown-item" onClick={() => handleNavigation('/admin/complaint')}>
                  <span className="dropdown-icon">📝</span>
                  Submit Complaint
                </button>
                <button className="dropdown-item" onClick={() => handleNavigation('/admin/subscription')}>
                  <span className="dropdown-icon">⭐</span>
                  Subscription
                </button>
                <button className="dropdown-item" onClick={() => handleNavigation('/admin/refer')}>
                  <span className="dropdown-icon">🎁</span>
                  Refer & Earn
                </button>
                <button className="dropdown-item" onClick={() => handleNavigation('/admin/contact')}>
                  <span className="dropdown-icon">📞</span>
                  Contact Us
                </button>
                <button className="dropdown-item logout-item" onClick={handleLogout}>
                  <span className="dropdown-icon">⏏️</span>
                  Logout
                </button>
              </div>
            )}
          </div>
        </nav>
      </div>
    </>
  );
};

export default Sidebar;
